import React, {useState} from 'react'
import axios from 'axios'

function CatalogosHomeItemDetalle(props) {
  const catalogoHome = props.catalogoHome

  const [inputFile, setInputFile] = useState('')
  const [nombreInput, setNombreInput] = useState('')

  let idElementoNum = catalogoHome.idElement.split('-')[2]
  let nombreString = catalogoHome.name

  const onChangeImage = (event) => {
    setInputFile(event.target.files)
    const [file] = event.target.files
    if (file) {
      document
        .getElementsByClassName('home-catalogo-' + idElementoNum)[0]
        .setAttribute('src', URL.createObjectURL(file))
      document.getElementById('ribbon-catalogo-' + idElementoNum).classList.remove('d-none')
    }
  }

  const onChangeNombre = (event) => {
    setNombreInput(event.target.value)
    document.getElementById('ribbon-catalogo-' + idElementoNum).classList.remove('d-none')
  }

  const onSubmit = () => {
    const API_URL = process.env.REACT_APP_API_URL

    const data = new FormData()

    for (let i = 0; i < inputFile.length; i++) {
      data.append('file[]', inputFile[i])
    }

    data.append('name', catalogoHome.idElement)
    data.append('elementName', document.getElementById('nombre-catalogo-' + idElementoNum).value)

    axios.post(API_URL + '/new-catalogo-home', data, {}).then(
      (res) => {
        document.getElementById('ribbon-catalogo-' + idElementoNum).classList.add('d-none')
      },
      (error) => {
        alert(error)
      }
    )
  }

  return(
    <div className='col-lg-3 catalogoitem' key={catalogoHome.idElement}>
      <div className='card card-custom overlay overflow-hidden bg-white'>
        <div className='card-body p-0 ribbon'>
          <div id={'ribbon-catalogo-' + idElementoNum} className='ribbon-label bg-danger d-none'>
            Sin guardar
          </div>
          <div className='overlay-wrapper'>
            <img
              src={catalogoHome.url}
              alt=''
              className={'w-100 rounded home-catalogo-' + idElementoNum}
            />
          </div>
          <div className='overlay-layer bg-dark bg-opacity-10'>
            <div className='d-flex flex-grow-1 flex-center py-5'>
              <input
                type='file'
                id={'file-catalogo-' + idElementoNum}
                name={'file-catalogo-' + idElementoNum}
                className='input-image'
                onChange={(event) => onChangeImage(event)}
              />
              <input
                id={'button-catalogo-' + idElementoNum}
                type='button'
                value='Cambiar...'
                className='btn btn-light-primary'
                onClick={() => document.getElementById('file-catalogo-' + idElementoNum).click()}
              />
            </div>
          </div>
        </div>
      </div>
      <label className='form-label mt-6'>Texto</label>
      <input
        id={'nombre-catalogo-' + idElementoNum}
        name={'nombre-catalogo-' + idElementoNum}
        className='form-control'
        defaultValue={nombreString}
        type='text'
        onChange={(e) => onChangeNombre(e)}
      />
      <div className='mt-4 float-end'>
        <button className='btn btn-primary btn-sm' onClick={() => onSubmit()}>
          Guardar
        </button>
      </div>
    </div>
  )
}

export {CatalogosHomeItemDetalle}